import { render, staticRenderFns } from "./plan_detail.vue?vue&type=template&id=a69a175c&scoped=true"
import script from "./plan_detail.vue?vue&type=script&lang=js"
export * from "./plan_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69a175c",
  null
  
)

export default component.exports